// extracted by mini-css-extract-plugin
module.exports = {"NavbarWrapper":"navbar-module--NavbarWrapper--7vC81","LinkWrapper":"navbar-module--LinkWrapper--1mbZn","DarkBtn":"navbar-module--DarkBtn--9NSAG"};